export default {

	fromCount: 0,

	range(min, max) {
		return Math.floor(Math.random() * (max - min + 1) + min)
	},

	from(arr, exclude) {
		if (arr.length < 1) throw Error('Empty array in RND.from')

		let res = this.range(0, arr.length - 1)

		if (this.fromCount > 50) {
			console.log('fromCount full')
			this.fromCount = 0
			return arr[res]
		}

		if (exclude) {
			if (Array.isArray(exclude)) {
				for (let i = 0; i < exclude.length; i++) {
					if (arr[res] === exclude[i]) {
						this.fromCount++
						return this.from(arr, exclude)
					}
				}
			} else {
				if (arr[res] === exclude) {
					this.fromCount++
					return this.from(arr, exclude)
				}
			}
		}

		if (this.fromCount !== 0) this.fromCount = 0
		return arr[res]
	},

	weighted(data) {
		let total = 0

		for (var id in data) {
			total += data[id]
		}

		let random = this.getUniform() * total

		let part = 0
		for (var id in data) {
			part += data[id]
			if (random < part) return id
		}

		return id
	},

	getSeed() {
		return this._seed
	},

	setSeed(seed) {
		seed = seed || Date.now()
		seed = (seed < 1 ? 1/seed : seed)

		this._seed = seed
		this._s0 = (seed >>> 0) * this._frac

		seed = (seed*69069 + 1) >>> 0
		this._s1 = seed * this._frac

		seed = (seed*69069 + 1) >>> 0
		this._s2 = seed * this._frac

		this._c = 1
		return this
	},

	getUniform() {
		let t = 2091639 * this._s0 + this._c * this._frac
		this._s0 = this._s1
		this._s1 = this._s2
		this._c = t | 0
		this._s2 = t - this._c
		return this._s2
	},

	getUniformInt(lowerBound, upperBound) {
		let max = Math.max(lowerBound, upperBound)
		let min = Math.min(lowerBound, upperBound)
		return Math.floor(this.getUniform() * (max - min + 1)) + min
	},

	getNormal(mean, stddev) {
		do {
			let u = 2*this.getUniform()-1
			let v = 2*this.getUniform()-1
			let r = u*u + v*v
		} while (r > 1 || r == 0)

		let gauss = u * Math.sqrt(-2*Math.log(r)/r)
		return (mean || 0) + gauss*(stddev || 1)
	},

	getPercentage() {
		return 1 + Math.floor(this.getUniform()*100)
	},

	getState() {
		return [this._s0, this._s1, this._s2, this._c]
	},

	setState(state) {
		this._s0 = state[0]
		this._s1 = state[1]
		this._s2 = state[2]
		this._c  = state[3]
		return this
	},

	clone() {
		let clone = Object.create(this)
		clone.setState(this.getState())
		return clone
	},

	_s0: 0,
	_s1: 0,
	_s2: 0,
	_c: 0,
	_frac: 2.3283064365386963e-10 /* 2^-32 */

}



// WEBPACK FOOTER //
// ./src/utils/random.js